module.exports = __webpack_public_path__ + "resources/img/img_secureguard_am1_m.0b71d105e55e82b00156bd57890bb0de.png";